import apiFarms from "../config/api_farms";
import getHeaders from "./getHeaders";

export function indexProductionOrders(payload) {
  const { groupId, farmId, status, startDate, endDate, signal } = payload;
  const params = new URLSearchParams();
  if (status) params.append("status", status);
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  const queryString = params.toString();

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/production/orders${
      queryString !== "" ? `?${queryString}` : ""
    }`,
    getHeaders(false, signal),
  );
}

export function showProductionOrder(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/${id}`,
    getHeaders(false, signal),
  );
}

export function checkProductionOrderRecipe(payload) {
  const { groupId, farmId, supplementId, signal } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/recipes/${supplementId}/readiness`,
    getHeaders(false, signal),
  );
}

export function calculateProductionOrder(payload) {
  const { groupId, farmId, body, signal } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/calculation`,
    body,
    getHeaders(false, signal),
  );
}

export function saveProductionOrder(payload) {
  const { groupId, farmId, body, signal } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/production/orders`,
    body,
    getHeaders(false, signal),
  );
}

export function updateProductionOrder(payload) {
  const { groupId, farmId, id, body, signal } = payload;

  return apiFarms.put(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/${id}`,
    body,
    getHeaders(false, signal),
  );
}

export function deleteProductionOrder(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiFarms.delete(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/${id}`,
    getHeaders(false, signal),
  );
}

export function indexProductionBatches(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/${id}/batches`,
    getHeaders(false, signal),
  );
}

export function executeProductionBatch(payload) {
  const { groupId, farmId, id, body, signal } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/${id}/batches`,
    body,
    getHeaders(false, signal),
  );
}

export function closeProductionOrderPartial(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/${id}/close/partial`,
    null,
    getHeaders(false, signal),
  );
}

export function scheduleProductionOrder(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/${id}/schedule`,
    null,
    getHeaders(false, signal),
  );
}

export function cancelProductionOrder(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/production/orders/${id}/cancel`,
    null,
    getHeaders(false, signal),
  );
}
